import { Routes } from '@angular/router';
import { ReactivationInfoComponent } from './reactivation-info/reactivation-info.component';
import { ReactivationCategoryComponent } from './reactivation-category/reactivation-category.component';
import { MainReactivationComponent } from './main-reactivation/main-reactivation.component';

export const REACTIVATION_MODULE_NOT_TRANSLATED: Routes = [
  {
    path: '', component: MainReactivationComponent, children: []
    // path: '', component: ReactivationInfoComponent, children: []
  },
  {path: 'info/:id', component: ReactivationCategoryComponent}

  // {
  //   path: 'id/:id', component: MainMissionRouteComponent, children: [
  //     { path: 'info', component: MissionRulesComponent }
  //   ]
  // },
];
